const styles = theme => ({
  inputContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  passwordInfoContainer: {
    margin: theme.spacing(1),
    color: theme.palette.primary.main,
    fontStyle: 'italic'
  },
  submitError: {
    textAlign: 'center',
    color: theme.palette.error.main,
    fontSize: 16,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  input: {
    width: 400,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
});

export default styles;
